import React from "react";

const Footer = () => (
    <footer style={{
        position: "relative",   // o "static"
        zIndex: 0,
        backgroundColor: "#2c2f32 ", // opcional para dar contraste
        padding: "10px",
        marginTop: "60px" // asegura que no esté pegado al contenido
    }}>
        <div className="contact-info">
            <p>Para contactar a nuestro equipo llama o escribe a:</p>
            <p>Tel: +54 9 3572 58-0412</p>
            <p>© Copyright Airasca & Asoc. Todos los derechos reservados.</p>
        </div>
        <div className="address">
            <p>San Juan 828, Río Segundo, Cordoba</p>
        </div>
    </footer>
);

export default Footer;
